
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { GrLocation } from "react-icons/gr";
import { IoBedOutline } from "react-icons/io5";
import { LiaBathSolid } from "react-icons/lia";
// import { BiArea } from "react-icons/bi";
import LoaderCard from "../components/loader";
import { getBlogsById, getListings } from "../service";

import { CgCalendarDates } from "react-icons/cg";
import { CiFileOn } from "react-icons/ci";
import { MdKeyboardArrowRight } from "react-icons/md";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { blogArray } from "../data/blogData";

// import img2 from "../assets/images/10-4-1-1-1.webp";
// import img4 from "../assets/images/2.6-6-1-1-525x328.webp";
// import img6 from "../assets/images/4-1-1-1-525x328.webp";
// import img5 from "../assets/images/5.3-3-1-1-525x328.webp";
// import img1 from "../assets/images/9.6-2-1-1-525x328.webp";
// import img3 from "../assets/images/j-1-1-1-525x328.webp";
// import img7 from "../assets/images/sell-1-1-1-525x328.webp";
// import img8 from "../assets/images/x-4-1-1-525x328.webp";
// import img9 from "../assets/images/vecteezy_happy-asian-couple-client-tenant-buy-home-realtor-hand_25133377.jpg";



const Blog = () => {

  // const blogArray = [
  //   {
  //     key: "Best areas for families with kids",
  //     img: img1,
  //     mainHead: "Best areas for families with kids",
  //     date: "March 4, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5  ",
  //     id: 1,
  //   },
  //   {
  //     key: "The top neighborhoods",
  //     img: img2,
  //     mainHead: "The top neighborhoods",
  //     date: "March 4, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5   ",

  //     id: 2,
  //   },
  //   {
  //     key: "Buyer's Guide",
  //     img: img3,
  //     mainHead: "Buyer's Guide",
  //     date: "May 27, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5  ",
  //     id: 3,
  //   },
  //   {
  //     key: "Seller's Guide",
  //     img: img4,
  //     mainHead: "Seller's Guide",
  //     date: "March 4, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5   ",
  //     id: 4,
  //   },
  //   {
  //     key: "Reasons to sell before New Year",
  //     img: img5,
  //     mainHead: "Reasons to sell before New Year",
  //     date: "May 27, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5   ",
  //     id: 5,
  //   },
  //   {
  //     key: "What to look for in an agent",
  //     img: img8,
  //     mainHead: "What to look for in an agent",
  //     date: "May 27, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5   ",
  //     id: 6,
  //   },
  //   {
  //     key: "The best of Torront’s vibrant cities from coast to coast",
  //     img: img7,
  //     mainHead: "The best of Torront’s vibrant cities from coast to coast",
  //     date: "May 27, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5  ",
  //     id: 7,
  //   },
  //   {
  //     key: "The Top 10 Attraction in Monteral",
  //     img: img6,
  //     mainHead: "The Top 10 Attraction in Monteral",
  //     date: "May 27, 2016",
  //     content:
  //       "New York County as a whole covers a total area of 33.77 square miles (87.5 km2), of which 22.96 square miles (59.5   ",
  //     id: 8,
  //   },
  // ];

  // const location = useLocation()
  // const navigate = useNavigate()
  const { key } = useParams();

  const [similarListings, setSimilarListings] = useState([]);
  const [similarlistingLoading, setSimilarListingLoading] = useState(false);
  const [blogValue, setBlogValue] = useState([])
  const [loading, setLoading] = useState(true)

  // const [currentIndex, setCurrentIndex] = useState(0);

  // const { selectedblog} = location.state || {}; 
  // console.log(selectedblog,"selectedblog");
  // const selectedblog = blogArray?.find((agent) => String(agent.id) === id);

  // const sliderSettings = {
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: false,
  //   autoplay: false,
  //   initialSlide: 0,
  //   afterChange: (index) => setCurrentIndex(index),
  // };


  const getBlogByIds = async (key) => {
    try {

      if (key) {
        const singleBlog = await getBlogsById(key);
        setBlogValue(singleBlog.data.data);
        console.log(singleBlog.data.data);
      }
    } catch (e) {
      throw e
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getFeatureListings();
    // if (key) {
    //   const selectedBlog = blogArray.find((blog) => blog.key === key);
    //   setBlogValue(selectedBlog)

    // }
    getBlogByIds(key)

  }, []);

  const getFeatureListings = async () => {
    setSimilarListingLoading(true);
    const filterQuery =
      "&propertyType=Detached&minBeds=5&minBaths=5&minPrice=5000000&maxPrice=10000000";
    try {
      const result = await getListings(1, 3, filterQuery);
      setSimilarListings(result.data.listings);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setSimilarListingLoading(false);
    }
  };
  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const options = { day: "2-digit", month: "short", year: "numeric" };
  //   const formattedDate = date.toLocaleDateString("en-GB", options);
  //   return formattedDate;
  // };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(price);
  };

  function formatDateToMonthYear(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  }







  const hanldeSub = (key) => {
    const selectedblog = blogArray?.find((agent) => agent.key === key);

    if (selectedblog) {
      // Open the link in a new window or tab
      const url = `/neighborhoods/${key}`;
      window.open(url, '_blank'); // Opens in a new tab
    }
  };
  const reduceText = (text) => {
    if (text.length > 100) {
      return text.substring(0, 150) + "...";
    }

    return text;
  };

  console.log("blog", blogValue);


  return (

    <div className="pt-24 pb-5  bg-gray-100 max-sm:pt-10" >


      <div className="m mx-10 flex gap-10 items-start container max-sm:flex-col md:flex-col lg:flex-row  " style={{ marginTop: "40px" }}>
        <div className="w-[70%]  flex flex-col  max-sm:w-[100%] md:w-[100%] lg:w-[70%]">

          <div className=" flex flex-col gap-10 overflow-scroll h-svh profile ">
            {/* {selectedblog.map((item, index) => ( */}
            {loading ? <>Loading</> :

              <div className="p-8 rounded-lg   bg-white shadow-md  max-sm:px-5">
                <h1 className=" font-bold hover:text-gold-400 text-start " style={{
                  fontFamily: '"Bodoni Moda", "Sans-serif"', fontSize: "30px",
                  color: "black",
                  lineHeight: "1.5em",
                }} >
                  {blogValue[0]?.title}
                </h1>
                <div className="">
                  <div className="flex  mt-5 max-sm:flex-col max-sm:gap-3 justify-between">
                    <div className="flex items-center gap-2">

                      <CgCalendarDates />
                      <h3 style={{ fontSize: "13px", color: "#464646" }} className="text-base">
                        {formatDateToMonthYear(blogValue[0]?.date)}
                      </h3>
                    </div>
                    <span className="flex items-center gap-3" style={{ fontSize: "14px" }}> <CiFileOn /><h3 style={{ fontSize: "13px", color: " #464646" }} className="text-base ">Buying Properties, Location, Price, Real Estate </h3> </span>

                  </div>

                </div>

                <div className="mt-2 text-start ">
                  {
                    blogValue[0]?.contents?.map((blog, i) =>
                      blog?.image?.url || blog?.content ? (
                        <div key={i}>
                          {blog?.title &&
                            <p className="font-medium text-xl mt-5" style={{
                              fontFamily: '"Bodoni Moda", "Sans-serif"',
                              color: "black",
                            }}>{blog?.title}</p>

                          }
                          {blog?.image?.url && (
                            <img
                              src={blog.image.url}
                              alt="home"
                              className="w-full h-full object-cover mt-5 mb-10"
                            />
                          )}
                          {blog?.content && (
                            <p style={{ fontSize: "14px", color: "#464646" }} className="mb-5">
                              {blog.content}
                            </p>
                          )}
                        </div>
                      ) : null
                    )
                  }
                </div>

              </div>
            }

            <div id="comments" className="p-6  rounded-md shadow-md bg-white ">
              <div id="respond" className="comment-respond">
                <h3 id="reply-title" className="text-lg font-bold mb-4 text-gray-800 text-start">
                  Leave a Reply
                  <small className="ml-2 text-sm">
                    <a
                      rel="nofollow"
                      id="cancel-comment-reply-link"
                      href="/find-the-most-attractive-townhouses-for-sale-in-austin/#respond"
                      className="text-blue-500 hover:underline hidden"
                    >
                      Cancel Reply
                    </a>
                  </small>
                </h3>
                <form
                  action="https://upbeat-perlman.35-203-5-196.plesk.page/wp-comments-post.php"
                  method="post"
                  id="commentform"
                  className="space-y-4"
                >
                  <p className="comment-notes text-sm text-gray-600 text-start">
                    Your email address will not be published.
                  </p>

                  <p className="comment-form-comment">
                    <textarea
                      id="comment"
                      name="comment"
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:bg-gray-200"
                      rows="5"
                      aria-required="true"
                      placeholder="Comment"
                    ></textarea>
                  </p>

                  <p className="comment-form-author">
                    <input
                      id="author"
                      name="author"
                      type="text"
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:"
                      placeholder="Name"
                      required
                    />
                  </p>

                  <p className="comment-form-email">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:bg-gray-200"
                      placeholder="Email"
                      required
                    />
                  </p>

                  <p className="comment-form-url">
                    <input
                      id="url"
                      name="url"
                      type="url"
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:bg-gray-200"
                      placeholder="Website"
                    />
                  </p>

                  <p className="comment-form-cookies-consent flex items-center space-x-2">
                    <input
                      id="wp-comment-cookies-consent"
                      name="wp-comment-cookies-consent"
                      type="checkbox"
                      className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring focus:bg-gray-200"
                    />
                    <label htmlFor="wp-comment-cookies-consent" className="text-sm text-gray-600">
                      Save my name, email, and website in this browser for the next time I comment.
                    </label>
                  </p>

                  <p className="form-submit text-start">
                    <button className="bg-[#D3B28C] text-white p-2 rounded-md hover:bg-[#C19F6B]">
                      Post Comment
                    </button>
                  </p>
                </form>
              </div>
            </div>


            {/* <div className="grid grid-cols-2 gap-6 max-sm:grid-cols-1">
  {blogArray.sort(() => Math.random() - 0.5).slice(0, 3).map((item, index) => (
    <div key={index} className="p-2 rounded-lg bg-white">
      <div className="h-[280px] p-2"
      onClick={()=>hanldeSub(item.key)}
      >
        <img
          src={item.img}
          alt="home"
          className="rounded-2xl w-full h-full object-cover transform hover:scale-105"
          style={{
            transition:
              "all 1s cubic-bezier(.3,1,.35,1) 0s, transform .5s ease",
          }}
        />
      </div>
      <div className="mt-2 bg-white text-start p-2">
        <h1 className="text-1xl text-black font-medium hover:text-gold-400">
          {item.mainHead}
        </h1>
        <h3 style={{fontSize:"13px" ,color:" #464646"}} className="text-base mt-2">{item.date}</h3>
        <h3 style={{fontSize:"13px" ,color:" #464646"}} className="text-base mt-2">{reduceText(item.content[0])}</h3>

        <p className="text-base font-semibold mt-2 flex  cursor-pointer "  onClick={()=>hanldeSub(item.key)} >  
         
         
          Continue Reading{" "}
          <span className="ml-2">
            {<MdKeyboardArrowRight size={24} />}
          </span>
        </p>
      </div>
    </div>
  ))}
</div> */}

          </div>

        </div>


        <div className="w-[30%] md:w-[100%] lg:w-[30%] max-sm:w-[100%] pt-2 px-4 shadow-lg overflow-scroll h-svh profile">
          <div className="mx-3">
            <h1 className="text-2xl font-bold text-start mt-4" style={{ fontFamily: '"Bodoni Moda", "Sans-serif"' }}>
              Latest Listings
            </h1>
          </div>
          <div className="p-1 px-3">
            <div className="flex justify-between items-center p-2">

            </div>
            {similarlistingLoading ? (
              Array.from({ length: 1 }).map((_, index) => (
                <LoaderCard key={index} />
              ))
            ) : (
              <div>
                {similarListings === 0 ? (
                  <div>...Oops no similar data found </div>
                ) : (
                  <>
                    {similarListings.map((item, index) => (
                      <div key={index}>
                        <div className="h-[350px] cursor-pointer m-2 relative bg-cover bg-center rounded-2xl overflow-hidden">
                          <img
                            src={item.images[0]}
                            alt="home"
                            className="rounded-2xl w-full h-full object-cover transform hover:scale-105"
                            style={{
                              transition:
                                "all 1s cubic-bezier(.3,1,.35,1) 0s, transform .5s ease",
                            }}
                            onClick={() =>
                              window.open(
                                `/property/${item.mlsNumber}`,
                                "_blank"
                              )
                            }
                          />
                          <div className="p-4 rounded-b-xl absolute top-[55%] w-full">
                            <div className="w-full bg-white px-5 py-3 flex flex-col rounded-xl gap-2 text-sm">
                              <div className="flex justify-start items-center">
                                <h2 className="text-lg text-[#006938] font-bold whitespace-nowrap">
                                  {formatPrice(item.listPrice)}
                                </h2>
                              </div>
                              <div className="flex gap-1 items-center">
                                <GrLocation size={20} className="shrink-0" />
                                <h2
                                  className="text-base max-2xl:text-sm  overflow-hidden text-start text-ellipsis font-normal whitespace-nowrap"
                                  data-tooltip-id="my-tooltip"
                                  data-tooltip-content={`${item.address.streetNumber} ${item.address.streetName}, ${item.address.city}, ${item.address.zip}`}
                                >{`${item.address.streetNumber} ${item.address.streetName}, ${item.address.city}, ${item.address.zip}`}</h2>
                              </div>
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                  <div className="flex gap-1 items-center">
                                    <IoBedOutline size={20} />
                                    <h4
                                      data-tooltip-id="my-tooltip"
                                      data-tooltip-content={
                                        item.details.numBedrooms
                                          ? item.details.numBedrooms
                                          : 0
                                      }
                                    >
                                      {item.details.numBedrooms
                                        ? item.details.numBedrooms
                                        : 0}
                                    </h4>
                                  </div>
                                  <span className="text-gray-300">|</span>
                                  <div className="flex gap-1 items-center">
                                    <LiaBathSolid size={20} />
                                    <h4
                                      data-tooltip-id="my-tooltip"
                                      data-tooltip-content={
                                        item.details.numBathrooms
                                          ? item.details.numBathrooms
                                          : 0
                                      }
                                    >
                                      {item.details.numBathrooms
                                        ? item.details.numBathrooms
                                        : 0}
                                    </h4>
                                  </div>
                                  {/* <span className="text-gray-300">|</span>
                                  <div className="flex gap-1 items-center">
                                    <BiArea size={20} />
                                    <h4
                                      className="truncate"
                                      data-tooltip-id="my-tooltip"
                                      data-tooltip-content={
                                        item.lot.width
                                          ? `${item.lot.depth} x ${item.lot.width}`
                                          : "0 x 0"
                                      }
                                    >
                                      {item.lot.width
                                        ? `${item.lot.depth} x ${item.lot.width}`
                                        : "0 x 0"}
                                    </h4>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
